import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetRewardProgramByLicensedEstablishmentId = ({
  licensedEstablishmentId,
  includeGlobal = false,
  enabled = true,
}: {
  licensedEstablishmentId: number
  includeGlobal?: boolean
  enabled?: boolean
}): UseQueryResult<Array<components['schemas']['FullRewardsProgramDTO']>> => {
  const get = useTypedApiClient({
    path: '/admin/rewards-programs/licensed-establishments/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: [
      '/admin/rewards-programs/licensed-establishments/{id}',
      licensedEstablishmentId,
    ],
    queryFn: async () => {
      const { data } = await get({ id: licensedEstablishmentId, includeGlobal })
      return data
    },
    enabled,
  })
}
